import styled from "styled-components";

export const ContainerContent = styled.div `
    /* width: 1100px; */
    max-width: 100%;
    margin: 0 auto;
    padding: 10px 0 0 0px;

    @media (max-width: 768px) {
        width: auto;
        padding:0px;
    }
`